// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const REVIEW_VERIFIED = "Overen\u00e1 recenzia";
